import styled from 'styled-components'
import SecondaryButton from '@components/inputs/button/secondaryButton'

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
`

export const Text = styled.div`
  font-family: Circular-Std;
  text-align: left;
`

export const DataContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
`

export const Button = styled(SecondaryButton)`
`

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`
